import { ref } from 'vue'

// Singleton state so the shell and the banner agree on visibility.
const isVisible = ref(false)

/**
 * Visibility of the mobile "Open app" banner.
 *
 * The banner is fixed to the viewport bottom (the shell is `100vh`, which on
 * mobile browsers is taller than the visible area, so an in-flow last row would
 * sit below the fold). AppOpenBanner publishes its visibility here and
 * GKRootContainer reserves matching bottom space in `<main>`, so the fixed bar
 * never overlays page content or controls.
 */
export const useAppOpenBanner = () => {
  const setVisible = (visible: boolean) => {
    isVisible.value = visible
  }

  return { isVisible, setVisible }
}
